// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_4292","icon":"_3669","message":"_3044"};